/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-28 11:34:43
 */
import { HomepageLucturerConfigModuleKey, HomepageProgressConfigModuleKey, HomepageProgressTitleConfigModuleKey, IsShowCoursePriceConfigModuleKey, OnlyShowLogoConfigModuleKey } from '@/config-center'
import instance from '@/service'
import SelectedCourseInstance from '@/service/selectedCourse'

import { IndexInfomationNavModel, Lecturer, SystemLessionTag } from './model'
import { setOrgId, getOrgId } from '@/utils/cookies'
export class IndexService {
  async getInfomationNavs (): Promise<Array<IndexInfomationNavModel>> {
    const result = await instance.get('/api/v1/menu/homePage/')
    return result.data.items.map((item: any) => {
      return new IndexInfomationNavModel(item.id, item.name)
    })
  }

  async getSystemLessionService () {
    const res = await instance.get('/api/v1/systemLessons/')
    return this.getSystemLessionDataFromServe(res.data)
  }

  getSystemLessionDataFromServe (initArr: Array<any>): Array<any> {
    return initArr.map((topItem: any) => {
      let children: Array<any> = []
      if (topItem.children.length > 0) {
        children = this.getSystemLessionDataFromServe(topItem.children)
      }
      return new SystemLessionTag(topItem.lessonSystemId, topItem.title, topItem.coverUrl, '', '', children)
    })
  }

  async getLecturers (): Promise<any> {
    const params = {
      page: 1,
      size: 100
    }
    const result = await instance.get('/api/v1/teachers/', { params })
    return result.data.items.map((item: any) => {
      return new Lecturer(item.teacherId, item.name, item.photo, item.content, item.position)
    })
  }

  async getCourseSystems (orgId: string): Promise<any> {
    const result = await instance.get(`/api/v1/admin/organizations/${orgId}/?key=homeSerise`)
    if (result.data[0].value) {
      const value = JSON.parse(result.data[0].value)
      return value
    } else {
      return []
    }
  }

  async getTeachers (orgId: string): Promise<any> {
    const result = await instance.get(`/api/v1/admin/organizations/${orgId}/?key=web-teachers`)
    if (result.data[0].value) {
      const value = JSON.parse(result.data[0].value)
      return value
    } else {
      return []
    }
  }

  async getStudyPlan (orgId: string): Promise<any> {
    const result = await instance.get(`/api/v1/admin/organizations/${orgId}/?key=homepage-learningplan`)
    if (result.data[0].value) {
      const value = JSON.parse(result.data[0].value)
      return value
    } else {
      return []
    }
  }

  async getInfoMenus (orgId: string): Promise<any> {
    const result = await instance.get(`/api/v1/admin/organizations/${orgId}/?key=news`)
    if (result.data[0].value) {
      const value = JSON.parse(result.data[0].value)
      return value
    } else {
      return []
    }
  }

  async getManual (orgId: string): Promise<any> {
    const result = await instance.get(`/api/v1/admin/organizations/${orgId}/?key=manual`)
    if (result.data[0].value) {
      const value = JSON.parse(result.data[0].value)
      return value
    } else {
      return []
    }
  }

  async getRelatedCourse (ids: Array<any>, orgId: string): Promise<any> {
    if (ids.length === 0) {
      return []
    }
    const result = await instance.post('/api/v1/home-index/lesson-system', ids)
    return result.data
  }

  async getOrgId (): Promise<string> {
    const result = await instance.get('/api/v1/configuration/center?moduleStatus=S005')
    // document.title = result.data.organizationTitle
    setOrgId(result.data.orgId)
    console.log('orgId', getOrgId())
    return result.data.orgId
  }

  // async getConfigWithProgress (): Promise<any> {
  //   const key = HomepageProgressConfigModuleKey
  //   const result = await instance.get(`/api/v1/admin/organizations/openKey/?key=${key}`)
  //   const item = result.data[0]
  //   if (!item) {
  //     return {
  //       title: '学习流程',
  //       series: []
  //     }
  //   }
  //   const items = JSON.parse(item.value)
  //   return {
  //     title: item.configModuleVariableId,
  //     series: items.map((subitem: any) => {
  //       return {
  //         title: subitem.title,
  //         sort: subitem.sort
  //       }
  //     })
  //   }
  // }

  // async getConfigWithShowCoursePrice (): Promise<any> {
  //   const key = IsShowCoursePriceConfigModuleKey
  //   const result = await instance.get(`/api/v1/admin/organizations/openKey/?key=${key}`)
  //   const item = result.data[0]
  //   if (!item) {
  //     return true
  //   }
  //   return item.value === 'true'
  // }

  // async getConfigWithProgressTitle (): Promise<any> {
  //   const key = HomepageProgressTitleConfigModuleKey
  //   const result = await instance.get(`/api/v1/admin/organizations/openKey/?key=${key}`)
  //   const item = result.data[0]
  //   if (!item) {
  //     return ''
  //   }
  //   return item.value
  // }

  // async getConfigWithShowLucturer (): Promise<any> {
  //   const key = HomepageLucturerConfigModuleKey
  //   const result = await instance.get(`/api/v1/admin/organizations/openKey/?key=${key}`)
  //   const item = result.data[0]
  //   if (!item) {
  //     return true
  //   }
  //   return item.value === 'true'
  // }

  async getSelectedCourse () {
    const res = await SelectedCourseInstance.get('/api/v2/excellentCourse/')
    return res
  }

  async getSelectedCourseVideos (excellentId: string, coursewareId: string) {
    const res = await instance.get(`/api/v2/excellentCourse/learnplan/${excellentId}/${coursewareId}/`)
    return res
  }
}
